import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BASE_PATH } from '../../api';
import { AuthService } from './auth.service';
import { EncoderService } from './encoder.service';

export type TipoCuenta = 'asociacion' | 'persona';

/**
 * Restablecimiento ADMINISTRATIVO de contraseñas (Wave 4): UN solo dato (la nueva contraseña), sin contraseña anterior ni confirmación.
 * La nueva contraseña viaja cifrada para el transporte, como en el login, y nunca se guarda ni se registra en el navegador. La API
 * exige el permiso global contrasenas:restablecer y audita cada operación; aquí no se decide ninguna autorización.
 * (El cambio de la contraseña de la propia asociación es otro flujo: POST /asociaciones/password, con la contraseña actual.)
 */
@Injectable({ providedIn: 'root' })
export class CredencialesAdminService {
  constructor(
    private readonly http: HttpClient,
    private readonly auth: AuthService,
    private readonly encoder: EncoderService,
    @Inject(BASE_PATH) private readonly basePath: string
  ) {}

  restablecer(tipo: TipoCuenta, id: number, passwordNueva: string): Observable<unknown> {
    const recurso = tipo === 'asociacion' ? 'asociaciones' : 'asociados';
    const headers = new HttpHeaders({ Authorization: 'Bearer ' + this.auth.getToken() });
    return this.http.post(`${this.basePath}/${recurso}/${encodeURIComponent(String(id))}/password`, { passwordNueva: this.encoder.encrypt(passwordNueva) }, { headers });
  }
}
